Ext.define('SA.model.createimport.FileTupleValidator', {
    constructor(tuple) {
        this.tuple = tuple;
        this.file = tuple.getFile();
        this.fileSchemaValidator = new SA.model.createimport.FileSchemaValidator(this.file);
    },

    getColumnCount() {
        return this.tuple.getColumnCount();
    },

    getFileSchemaValidator() {
        return this.fileSchemaValidator;
    },

    hasFileWithoutUnit() {
        return !this.hasNullFile() && !this.hasUnit();
    },

    hasInvalidFile() {
        return !this.fileSchemaValidator.isValid();
    },

    hasNullFile() {
        return this.file.isNull();
    },

    hasReadableFile() {
        return this.file.isReadable();
    },

    hasUnit() {
        return !!this.tuple.getUnit();
    },

    hasUnitWithoutFile() {
        return this.hasUnit() && this.hasNullFile();
    },

    isValid() {
        return this.hasReadableFile() && this.hasUnit() && this.fileSchemaValidator.isValid();
    }
});